(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.controller.debt-financing
  (:require
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.component.lp-portal.donut-chart.view :as donut-chart]
   [frontend.ui.component.chart.utils :as chart-utils]))

(defn- ->lender-by-loans-outstanding
  [chart-data-debt-financing]
  (let [data (->> (util/->array-of-tuples chart-data-debt-financing :commitment)
                  (sort-by second)
                  (reverse))]
    (donut-chart/donut-chart-config data
                                    {:data-label-formatter
                                     chart-utils/pie-float-label-formatter-divide-m})))

(defn ->debt-financing
  [{:keys [dynamic-path dynamic-data report-data map-topo] :as props}]
  {:description-text (report-ctl/rich-content props :description-text)
   :debt-key-figures (report-ctl/with-footnote
                       props
                       :debt-key-figures-footnotes
                       (get-in report-data [:portfolio-debt-key-figures]))
   :portfolio-debt-financing (report-ctl/with-footnote
                               props
                               :debt-financing-footnotes
                               (get-in report-data [:portfolio-debt-financing]))
   :hedging          (report-ctl/with-footnote
                       props
                       :hedging-footnotes
                       (get-in report-data [:hedging]))
   :lender-by-loans-outstanding
   (report-ctl/with-footnote
     props
     :lender-by-loans-outstanding-footnotes
     (->lender-by-loans-outstanding (get-in report-data [:chart-data-debt-financing])))
   :major-tenants      (report-ctl/with-footnote
                         props
                         :major-tenants-footnotes
                         (get-in report-data [:major-tenants]))
   :nav-breakdown      (report-ctl/with-footnote
                         props
                         :nav-breakdown-footnotes
                         (get-in report-data [:nav-breakdown]))
   :inrev-nav          (report-ctl/with-footnote
                         props
                         :inrev-nav-footnotes
                         (get-in report-data [:inrev-nav]))
   :limited-partners   (report-ctl/with-footnote
                         props
                         :limited-partners-footnotes
                         (get-in report-data [:limited-partners]))})
